import { render } from "./TarefasSemValidade.vue?vue&type=template&id=78c5ecec&scoped=true"
import script from "./TarefasSemValidade.vue?vue&type=script&lang=js"
export * from "./TarefasSemValidade.vue?vue&type=script&lang=js"

import "./TarefasSemValidade.vue?vue&type=style&index=0&id=78c5ecec&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c5ecec"]])

export default __exports__